import { render, staticRenderFns } from "./doc-text.vue?vue&type=template&id=04a63be0&scoped=true&"
import script from "./doc-text.vue?vue&type=script&lang=js&"
export * from "./doc-text.vue?vue&type=script&lang=js&"
import style0 from "./doc-text.vue?vue&type=style&index=0&id=04a63be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a63be0",
  null
  
)

export default component.exports